import { RecordLogLevel } from "graphql/generated/graphql";
import { getListFromGraphql } from "utils/utils";

const initialRowsPerPage = 10;
const initialOrder = "-created_at";

export const initialQuery = {
    limit: initialRowsPerPage as typeof initialRowsPerPage,
    offset: 0,
    order: initialOrder,
};

export const logListPathFragment = "log-list";

// localStorage tableSettings key for the record-log list, so page size / sort
// order persist across navigation and reload (parity with other record lists).
export const recordLogListKey = "recordLogList";

export const getRecordLogLevelList: () => RecordLogLevel[] = () =>
    getListFromGraphql("RecordLogLevel");
